//import beautify from './beautify'
//import json from './json'
import fetch from './fetch'
import number from './number'
import moment from './moment'
import path from './path'
import expression from './expression'
import matrix from './matrix'
import dom from './dom'
import password from './password'
import string from './string'
import exception from './exception'
import tree from './tree'
import history from './history'
//import less from './less'
import _ from 'lodash'
import ui from './ui'
//import pubSub from 'pubsub-js'

export default {
	//beautify,
	//json,
	fetch,
	number,
	string,
	moment,
	path,
	expression,
	matrix,
	dom,
	password,
	exception,
	tree,
	history,
	//less,
	_,
	//ui
}